export enum ActionBarState {
  'Default' = 'default',
  'Extended' = 'extended',
  'Minimized' = 'minimized'
}
